import { render, staticRenderFns } from "./businessRegister.pug?vue&type=template&id=b96218fc&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./businessRegister.scss?vue&type=style&index=0&id=b96218fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96218fc",
  null
  
)

export default component.exports